import React from "react";
import { AccesoDirectoHomeItem } from "../models/dataModels";


interface AccesoDirectoEnlaceProps {
    accesoDirecto: AccesoDirectoHomeItem;
}


function AccesoDirectoEnlace(props: AccesoDirectoEnlaceProps): JSX.Element {

    return <a href={props.accesoDirecto.urlEnlace} title={props.accesoDirecto.titulo} target={props.accesoDirecto.abrirEnNuevaVentana ? "_blank" : "_self"}>
        <img src={props.accesoDirecto.urlCaratula} className="img-fluid" alt={props.accesoDirecto.titulo} />
    </a>;
}

export default AccesoDirectoEnlace;
